import { action } from 'typesafe-actions';
import { AdminTypes } from './types';

export const fetchDashboardRequest = () =>
  action(AdminTypes.FETCH_DASHBOARD_REQUEST);

export const fetchDashboardSuccess = (data: any) =>
  action(AdminTypes.FETCH_DASHBOARD_SUCCESS, data);

export const fetchDashboardFailure = () =>
  action(AdminTypes.FETCH_DASHBOARD_FAILURE);

export const fetchUsersRequest = () =>
  action(AdminTypes.FETCH_USERS_REQUEST);

export const fetchUsersSuccess = (users: any[]) =>
  action(AdminTypes.FETCH_USERS_SUCCESS, { users });

export const fetchUsersFailure = () =>
  action(AdminTypes.FETCH_USERS_FAILURE);

export const fetchUserDetailRequest = (id: string) =>
  action(AdminTypes.FETCH_USER_DETAIL_REQUEST, { id });

export const fetchUserDetailSuccess = (data: any) =>
  action(AdminTypes.FETCH_USER_DETAIL_SUCCESS, data);

export const fetchUserDetailFailure = () =>
  action(AdminTypes.FETCH_USER_DETAIL_FAILURE);

export const fetchPaymentsRequest = (filters?: any) =>
  action(AdminTypes.FETCH_PAYMENTS_REQUEST, { filters });

export const fetchPaymentsSuccess = (payments: any[]) =>
  action(AdminTypes.FETCH_PAYMENTS_SUCCESS, { payments });

export const fetchPaymentsFailure = () =>
  action(AdminTypes.FETCH_PAYMENTS_FAILURE);
